export const alphabet = [ ...'abcdefghijklmnopqrstuvwxyz' ];